import Vue, { VNode, VNodeDirective } from "vue";

const TAP_EVENT_NAME = "tap-touch";

Vue.directive("tap-touch", {
	// eslint-disable-next-line max-lines-per-function
	bind(el:HTMLElement, binding:VNodeDirective, vnode:VNode) {
		let isTap = false;
		el.addEventListener("touchstart", (event:TouchEvent) => {
			if (event.touches.length > 1) {
				isTap = false;
				return;
			}
			isTap = true;
			setTimeout(() => {
				isTap = false;

			}, binding.value || 300);
		});
		el.addEventListener("touchmove", (event:TouchEvent) => {
			isTap = false;
		});
		el.addEventListener("touchend", (event:TouchEvent) => {
			if (!isTap) {
				return;
			}
			if (vnode.data) {
				let handlers = vnode.data.on;
				if (handlers) {
					let toTriggerHandlers = handlers[TAP_EVENT_NAME] || [];
					if (typeof(toTriggerHandlers) == "function") {
						toTriggerHandlers(event);
					} else {
						for (let handler of toTriggerHandlers) {
							handler(event);
						}
					}
				}
			}
			if (vnode.componentOptions) {
				let handlers = vnode.componentOptions.listeners as any;
				if (handlers) {
					let toTriggerHandlers = handlers[TAP_EVENT_NAME] || [];
					if (typeof(toTriggerHandlers) == "function") {
						toTriggerHandlers(event);
					} else {
						for (let handler of toTriggerHandlers) {
							handler(event);
						}
					}
				}
			}
		});
	}
});